import { TypeCompModel } from '../simple-types/type-comp.model';
import { SocieteLinkedModel } from './societe-linked.model';


export class CompModel extends SocieteLinkedModel {
    idTypeComp: number;
    typeComp: TypeCompModel;
}
